import Constant from "@/common/constant/Constant";
import Utils, { isAdminUser } from "@/common/utils/utils";
import { getHelpDeskListData, getListGuestProject, getProjectInCorporationByProjectType, getProjectListInCorporation } from "@/service/projectService";
import { getUserListInProjectByProjectId } from "@/service/userService";
import { cloneDeep } from "lodash";

/**
 * changeMasterItemTypeSelected
 * @param {*} event 
 * @param {*} currentField 
 * @param {*} argsCommon 
 * @returns 
 */
export const changeMasterItemTypeSelected = (event, currentField, argsCommon) => {
    let newType = event.target.value;
    if (!newType) return;

    if (currentField.structure?.masterItemTypeSelected === newType) return;
    currentField.structure['masterItemTypeSelected'] = newType;
    argsCommon.setMasterItemTypeSelected(newType);
}


/**
 * changeMasterItemCorporationSelected
 * @param {*} event 
 * @param {*} currentField 
 * @param {*} argsCommon 
 * @returns 
 */
export const changeMasterItemCorporationSelected = (event, currentField, argsCommon) => {
    let newCorporationType = event.target.value;
    if (!newCorporationType) return;

    if (currentField.structure?.masterItemCorporationSelected === newCorporationType) return;
    currentField.structure['masterItemCorporationSelected'] = newCorporationType;
    argsCommon.setMasterItemCorporationSelected(newCorporationType);
}

/**
 * changeMasterItemProjectSelected
 * @param {*} event 
 * @param {*} currentField 
 * @param {*} argsCommon 
 * @returns 
 */
export const changeMasterItemProjectSelected = (event, currentField, argsCommon) => {
    let newProjectType = event.target.value;
    if (!newProjectType) return;

    if (currentField.structure?.masterItemProjectSelected === newProjectType) return;
    currentField.structure['masterItemProjectSelected'] = newProjectType;
    argsCommon.setMasterItemProjectSelected(newProjectType);
}

/**
 * changeMasterItemUserSelected
 * @param {*} event 
 * @param {*} currentField 
 * @param {*} argsCommon 
 * @returns 
 */
export const changeMasterItemUserSelected = (event, currentField, argsCommon) => {
    let newUserType = event.target.value;
    if (!newUserType) return;

    if (currentField.structure?.masterItemUserSelected === newUserType) return;
    currentField.structure['masterItemUserSelected'] = newUserType;
    argsCommon.setMasterItemUserSelected(newUserType);
}


export const getMasterItemList = async (argsCommon) => {
    if (!argsCommon.masterItemTypeSelected || !argsCommon.masterItemCorporationSelected) {
        return {};
    }

    let dataList = {};
    let activeList = [];
    let inactiveList = [];

    switch (argsCommon.masterItemTypeSelected) {
        case Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER:
            dataList = await getMasterItemUserList(argsCommon);
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.PROJECT:
            dataList = await getMasterItemProjectList(argsCommon);
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.CORPORATION:
            dataList = await getMasterItemCorporationList(argsCommon);
            break;

        default:
            break;
    }

    if (!Utils.isEmptyObject(dataList)) {
        activeList = dataList.activeList;
        inactiveList = dataList.inactiveList;
    }

    return { activeList, inactiveList }
}

export const getMasterItemUserList = async (argsCommon) => {
    let corporationRange = await getMasterItemCorporationList(argsCommon);
    let allCorporation = corporationRange.allCorporation;

    let projectRange = await getMasterItemProjectList(argsCommon);
    let allProject = projectRange.allProject;

    let allUser = [];
    let activeList = [];
    let inactiveList = [];

    if (Utils.isEmptyArray(allCorporation) || Utils.isEmptyArray(allProject)) {
        return { activeList, inactiveList, allUser }
    }

    let totalUser = [];
    await Promise.all(
        allProject.map(async (projectData) => {
            let projectAllUser = await getUserListInProjectByProjectId(argsCommon.API, projectData.id);
            if (!Utils.isEmptyArray(projectAllUser)) {
                totalUser = totalUser.concat(projectAllUser);
            }
        })
    );

    if (Utils.isEmptyArray(totalUser)) {
        return { activeList, inactiveList, allUser }
    }

    switch (argsCommon.masterItemUserSelected) {
        case Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ALL:
            allUser = totalUser;
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.GENERAL:
            allUser = totalUser.filter(item => Utils.isGeneralUserWithoutGuest(item));
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ADMIN:
            allUser = totalUser.filter(item => isAdminUser(item));
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.PROJECT_MANAGER:
            allUser = totalUser.filter(item => item.projectDetail?.isProjectManager === true);
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.INTERNAL_CUSTOMER:
            allUser = totalUser.filter(item => item.type === Constant.USER_TYPE.INTERNAL);
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.B2C_CUSTOMER:
            allUser = totalUser.filter(item => item.type === Constant.USER_TYPE.CUSTOMER);
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.GUEST:
            allUser = totalUser.filter(item => Utils.isGuestUser(item));
            break;
        default:
            break;
    }

    let allUserResult = [];

    if (!Utils.isEmptyArray(allUser)) {
        allUser.forEach(user => {
            if (Utils.findIndexInArrayById(user.id, allUserResult) === -1) {
                allUserResult.push(user);
            }
        })
    }
    
    activeList = allUserResult;

    return { activeList, inactiveList, allUser: allUserResult }
}

export const getMasterItemProjectList = async(argsCommon) => {
    let corporationRange = await getMasterItemCorporationList(argsCommon);
    let allCorporation = corporationRange.allCorporation;

    let allProject = [];
    let activeList = [];
    let inactiveList = [];

    if (Utils.isEmptyArray(allCorporation)) {
        return { activeList, inactiveList, allProject }
    }

    switch (argsCommon.masterItemProjectSelected) {
        case Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.INUSE:
            if (argsCommon.masterItemCorporationSelected === Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.INUSE) {
                allProject = [argsCommon.currentProjectDetail];
            }
            break;
        case Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.ALL:
            await Promise.all(
                allCorporation.map(async (corpData) => {
                    let corporationAllProject = await getProjectListInCorporation(argsCommon.API, corpData.id);
                    if (!Utils.isEmptyArray(corporationAllProject)) {
                        allProject = allProject.concat(corporationAllProject);
                    }
                })
            );
            break;
        default:
            await Promise.all(
                allCorporation.map(async (corpData) => {
                    let corporationAllProject = await getProjectInCorporationByProjectType(argsCommon.API, corpData.id, argsCommon.masterItemProjectSelected);
                    if (!Utils.isEmptyArray(corporationAllProject)) {
                        allProject = allProject.concat(corporationAllProject);
                    }
                })
            );
            break;
    }

    activeList = allProject;

    return { activeList, inactiveList, allProject };
}

export const getMasterItemCorporationList = async (argsCommon) => {
    let allCorporation = [];
    let activeList = [];
    let inactiveList = [];

    if (argsCommon.masterItemCorporationSelected === Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.INUSE) {
        allCorporation = [argsCommon.currentCorporationDetail];
    } else if (argsCommon.masterItemCorporationSelected === Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.CUSTOMER) {
        let listGuestData = await getListGuestProject(argsCommon.API, argsCommon.currentProjectDetail);
        allCorporation = listGuestData.corporationList;
    } else if (argsCommon.masterItemCorporationSelected === Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.SUPPORT) {
        let listHelpDeskData = await getHelpDeskListData(argsCommon.API, argsCommon.currentProjectDetail);
        allCorporation = listHelpDeskData.corporationList;
    }

    activeList = allCorporation;

    return { activeList, inactiveList, allCorporation };
};

export const onDragEnd = (result, argsCommon) => {
    // dropped outside the list
    if (!result.destination) {
        return;
    }

    let startIndex = result.source.index;
    let endIndex = result.destination.index;

    let activeListClone = cloneDeep(argsCommon.activeList);
    let [removed] = activeListClone.splice(startIndex, 1);
    activeListClone.splice(endIndex, 0, removed);
    argsCommon.setActiveList(activeListClone);
};

export const onBeforeDragStartHandler = (event, argsCommon) => {
    //disable slide before drag start
    let newSetting = cloneDeep(argsCommon.settingSlideRecoilState);
    newSetting.disable = true;

    argsCommon.setSettingSlideRecoilState(newSetting);
}